import { render } from "./TOS.vue?vue&type=template&id=5a969ba8"
import script from "./TOS.vue?vue&type=script&lang=ts"
export * from "./TOS.vue?vue&type=script&lang=ts"
script.render = render

export default script